import { render, staticRenderFns } from "./InstallModal.vue?vue&type=template&id=5e8cf34e"
import script from "./InstallModal.vue?vue&type=script&lang=js"
export * from "./InstallModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports